<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="60px">
        <el-row>
          <el-col :span="1">
            <el-form-item label="帮还">
              <el-checkbox
                v-model="bhbt"
                @change="bttypesChange(1)"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item label="住宿">
              <el-checkbox
                v-model="zsbt"
                @change="bttypesChange(2)"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item label="补贴">
              <el-checkbox
                v-model="xxbt"
                @change="bttypesChange(3)"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label=" ">
              <el-input
                v-model="searchParams.stu"
                placeholder="学生姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="box">
            <div class="box2">
              <el-button
                type="success"
                size="mini"
                @click="search(-11)"
                v-if="navi && navi.prev"
              >
                《《
              </el-button>
              <el-date-picker
                v-model="month"
                type="month"
                placeholder="选择月"
                value-format="yyyy-MM"
                @change="search(1)"
              >
              </el-date-picker>
              <el-button
                type="success"
                size="mini"
                @click="search(11)"
                v-if="navi && navi.next"
                >》》</el-button
              >
            </div>
          </el-col>
          <div class="search-btn">
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button @click="clearSearchVal">清空</el-button>
            {{ countStr }}
            <el-button
              v-has-permission-code-and="'003500150010'"
              @click="toFafang"
              >发放</el-button
            >
          </div>
        </el-row>
      </el-form>
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table
        class="table"
        :data="listData.records"
        stripe
        border
        height="auto"
        @selection-change="selectionChange"
        v-loading="listLoading"
      >
        <el-table-column
          type="selection"
          width="55"
          fixed="left"
        ></el-table-column>
        <el-table-column
          width="110"
          prop="bttm"
          label="补贴时间"
        ></el-table-column>
        <el-table-column
          width="85"
          prop="dbColumn_stuid"
          label="补贴学生"
        ></el-table-column>
        <el-table-column
          width="85"
          prop="type"
          label="补贴类型"
        ></el-table-column>
        <el-table-column
          width="55"
          prop="bttimes"
          label="期数"
        ></el-table-column>
        <el-table-column
          width="65"
          prop="btcost"
          label="金额"
        ></el-table-column>
        <el-table-column width="95" prop="buall" label="总计"></el-table-column>
        <el-table-column
          width="110"
          prop="paydate"
          label="发放时间"
        ></el-table-column>
        <el-table-column
          width="110"
          prop="crtm"
          label="创建时间"
        ></el-table-column>
        <el-table-column
          width="75"
          prop="dbColumn_crer"
          label="创建人"
        ></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column label="操作" fixed="right" width="185px">
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button
                v-has-permission-code-and="'003500150000'"
                size="mini"
                @click="toAddRmk(scope.$index, scope.row)"
                >备注</el-button
              >
              <el-button
                v-has-permission-code-and="'003500150004'"
                size="mini"
                type="danger"
                v-if="!scope.row.paydate"
                @click="remove(scope.$index, scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBar">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :total="listData.total"
          :page-size="page.size"
          :current-page="page.current"
          :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="添加备注"
      :visible.sync="dialogVisible"
      width="25%"
      :before-close="handleClose"
      :modal="false"
    >
      <br />
      <span
        >{{ msg }}:<br />
        <el-input
          type="textarea"
          rows="2"
          v-model="remark"
          autocomplete="off"
        ></el-input> </span
      ><br />

      <span slot="footer" class="dialog-footer">
        <el-button @click="addRmk">添 加</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

       <el-dialog
      title="批量发放"
      :visible.sync="dialogVisible2"
      width="25%"
      :before-close="handleClose"
      :modal="false"
    >
      <span
        >{{ countStr }}:<br /><br />
        <el-date-picker
          v-model="paydate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker> </span
      ><br />
      <span slot="footer" class="dialog-footer">
        <el-button @click="faFang">发 放</el-button>
        <el-button @click="dialogVisible2 = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/api/cw/butiestu.js";
import Index from "../../index.vue";
export default {
  name: "butiestu",
  components: {
    Index,
  },
  data() {
    return {
      searchParams: {},
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      selected2: [],
      countStr: "",
      page: new this.$constant.pageObj(),
      dialogVisible: false,
      dialogVisible2: false,
      paydate:"",
      remark: "",
      remarkid: "",
      msg: "",
      bhbt: true,
      zsbt: true,
      xxbt: true,
      month: "",
      navi: {},
      bttypes: ["帮还", "住宿", "学习"],
    };
  },
  methods: {
    handleClose() {},
    //获取数据
    list() {
      this.listLoading = true;
      let params = this.$utils.merger(this.searchParams, this.page);
      api.list(params, (response) => {
        this.listData = response.data.bt;

        if (response.data.navi) {
          // 可以导航的月份
          this.navi = response.data.navi;
          // 解析时间
          this.month = new Date(this.navi.crnt.replaceAll("-", "/") + "/01");
        } else {
          this.month = null;
        }

        this.listLoading = false;
      });
    },
    //去详情
    toAddRmk(index, row) {
      this.dialogVisible = true;
      this.msg =
        row.dbColumn_stuid +
        " 第" +
        row.bttimes +
        "期[" +
        row.type +
        "]补贴：" +
        row.btcost +
        "元备注";
      this.remark = row.remark;
      this.remarkid = row.id;
    },
    addRmk() {
      api.rmk({ id: this.remarkid, bz: this.remark }, (response) => {
        this.$utils.msg.success(response.msg);
        this.list();
        this.dialogVisible = false;
      });
    },
    //删除
    remove(index, row) {
      let parameter = {
        ids: row.id,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //发放
    toFafang() {
      if (this.selected.length < 1) {
        this.$utils.msg.warning("请选择操作的行!");
        return;
      }

      if (this.selected2 > 0) {
        this.$utils.msg.warning("所选行:存在已发放!");
        return;
      }  
      this.dialogVisible2 = true;
    
    },faFang(){
         if(this.paydate && this.paydate.length>0){
           api.fafa({ ids: this.selected,paydate:this.paydate }, (response) => {
            this.$utils.msg.success(response.msg);
                this.dialogVisible2 = false;
                this.list();
           });
         }else{
            this.$utils.msg.warning("请选择发放日期!");
         }
    },
    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      this.selected2 = 0;
      let sumVal = 0;

      for (let item of val) {
        this.selected.push(item.id);
        this.selected2 += item.paydate ? 1 : 0;
        sumVal += item.btcost;
      }

      if (this.selected.length > 0) {
        this.countStr = this.selected.length + " 项,需支付: " + sumVal + " 元";
      } else {
        this.countStr = "";
      }
    },
    bttypesChange(type) {
      if (type == 1) {
        if (this.bhbt) {
          this.bttypes.push("帮还");
        } else {
          this.bttypes.remove("帮还");
        }
      } else if (type == 2) {
        if (this.zsbt) {
          this.bttypes.push("住宿");
        } else {
          this.bttypes.remove("住宿");
        }
      } else {
        if (this.xxbt) {
          this.bttypes.push("学习");
        } else {
          this.bttypes.remove("学习");
        }
      }
      if (!this.bhbt) {
        if (!this.zsbt) {
          if (!this.xxbt) {
                 this.bhbt = true
				  this.zsbt = true
				   this.xxbt = true
          }
        }
      }

      this.search();
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },

    //搜索
    search(type) {
      if (type == -11) {
        //上1月
        this.searchParams = { month: this.navi.prev };
      } else if (type == 11) {
        //下1月
        this.searchParams = { month: this.navi.next };
      } else if (type == 1) {
        // 时间选择器
        this.searchParams = { month: this.month };
      } else {
        if (this.searchParams.stu) {
          this.searchParams = { stu: this.searchParams.stu };
        }
      }

      if (this.bttypes.length > 0) {
        this.searchParams.types = this.bttypes;
      }

      this.list();
    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = {};
    },
  },
  mounted() {
    this.list();
    Array.prototype.indexOf = function (val) {
      for (var i = 0; i < this.length; i++) {
        if (this[i] == val) return i;
      }
      return -1;
    };
    Array.prototype.remove = function (val) {
      var index = this.indexOf(val);
      if (index > -1) {
        this.splice(index, 1);
      }
    };
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
.box {
  display: flex;
}
.box2 {
  display: flex;
  margin: 0px 10px;
}
</style>